import React, { Component } from 'react';
import { Route, Routes, useLocation, useNavigate, useParams, } from 'react-router-dom';
import { Layout } from './components/Layout';
import Home from './components/Home';
import Stammdaten from './components/Stammdaten/Stammdaten';
import KitaStammdaten from './components/Stammdaten/KitaStammdaten';
import Ergebnisse from './components/Ergebnisse/Ergebnisse';
import KitaErgebnisse from './components/Ergebnisse/KitaErgebnisse';
import StartTest from './components/Test/StartTest';
import Test from './components/Test/Test';
import KitaTest from './components/Test/KitaTest';
import Auth from './components/Auth/Auth';
import Logout from './components/Auth/Logout/Logout';
import Benutzer from './components/Benutzer/Benutzer';
import Auswertung from './components/Auswertung/Auswertung';
import PasswortAendern from './components/Auth/PasswortAendern';
 
import {connect} from 'react-redux';

import './custom.css'
import * as actions from './store/actions/index';
import StartKitaTest from './components/Test/StartKitaTest';

class App extends Component {
componentDidMount() {
  this.props.onTryAutoSignup();
}

  static displayName = App.name;

  render () {
    return (
        <Layout>
            <Routes>
                <Route path="/" exact element={<Home/>} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/benutzer" element={<Benutzer />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/updatePassword" element={<PasswortAendern />} />
                <Route path="/stammdaten" element={<Stammdaten/>} />
                <Route path="/ergebnisse" element={<Ergebnisse/>} />
                <Route path="/auswertung" element={<Auswertung/>} />
                <Route path="/test" element={<Test/>} />
                <Route path="/kita-test" element={<KitaTest/>} />
                <Route path="/start-test" element={<StartTest/>} />
                <Route path="/start-kita-test" element={<StartKitaTest />} />
                <Route path="/kita-ergebnisse" element={<KitaErgebnisse />} />
                <Route path="/kita-stammdaten" element={<KitaStammdaten />} />

            </Routes>
      </Layout>
    );
  };
};

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
        <Component
            {...props}
            location={location}
            params={params}
            navigate={navigate}
        />
    );
  }

  return ComponentWithRouterProp;
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default withRouter(connect(null,mapDispatchToProps)(App));